import { format, isValid, parseISO } from "date-fns";
import { TRANG_THAI_VALUES } from "pages/theo-doi-vi-pham/constant";

export const formatDate = (date: Date | string | undefined) => {
  return date ? format(date, "dd-MM-yyyy hh:mm") : "";
};

export const formatCurrency = (value: number) => {
  return value.toLocaleString("en-US");
};

const isDate = (value: string) => {
  try {
    const dateString = parseISO(value);
    return isValid(dateString);
  } catch (error) {
    return false;
  }
};
export const formatDetailPage = (data: any | undefined) => {
  if (!data) {
    return {};
  }
  const newData = Object.entries(data).reduce((acc, [key, value]) => {
    if (isDate(value as string)) {
      acc[key] = formatDate(value as any);
    } else if (key === "gioiTinh") {
      acc[key] = value === 0 ? "Nam" : "Nữ";
    } else if (key === "masterTinhThanhPhoId") {
      acc[key] = data?.masterTinhThanhPho?.ten;
    } else if (key === "masterQuanHuyenId") {
      acc[key] = data?.masterQuanHuyen?.ten;
    } else if (key === "masterPhuongXaId") {
      acc[key] = data?.masterPhuongXa?.ten;
    } else if (key === "donViId") {
      acc[key] = data?.donVi?.ten;
    } else if (key === "SampleId") {
      acc[key] = data?.Sample?.ten;
    } else if (key === "idPhienDauGia" || key === "phienDauGiaId") {
      acc[key] = data?.phienDauGia?.soGiayPhep;
    } else if (key === "trangThai") {
      acc[key] = TRANG_THAI_VALUES[data.trangThai];
    } else if (key === "idTaiSan" || key === "taiSanDauGiaThanhCongId") {
      acc[key] = data?.taiSan?.tenTaiSan;
    } else if (key === "idQuanLyDauGia") {
      acc[key] = data?.quanLyDauGia?.ghiChu;
    } else if (key === "hoSoCaNhanId") {
      acc[key] = data?.hoSoCaNhan?.hoTen;
    } else if (key === "masterLoaiTaiSanId") {
      acc[key] = data?.masterLoaiTaiSan?.mota;
    } else if (typeof value === "number") {
      acc[key] = value.toLocaleString("en-US");
    } else if (typeof value === "boolean") {
      acc[key] = value ? "Có" : "Không";
    } else {
      acc[key] = value;
    }
    return acc;
  }, {} as any);

  return newData;
};

//key.includes("ngay")
